module.exports = __webpack_public_path__ + "static/img/barGraph.e2465c02.svg";